import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import "primeflex/primeflex.css";
import "./Dashboard.scss";
import AshaAnmSectionView from "./AshaAnmSection/AshaAnmSectionView";
import { useTranslation } from 'react-i18next';
const DashboardSection = () => {
 const { t } = useTranslation();
  return (
    <div className="dashboard-sections">
      <Accordion multiple activeIndex={[0]} >
        <AccordionTab
          header={
            <div className="flex align-items-center line-height-2 justify-content-between">
              <div className="vertical-align-middle" style={{color:"#1D2965"}}>
               {t("ASHAANM")}
              </div>
            </div>
            } >
            <div><AshaAnmSectionView/></div>
        </AccordionTab>
        {/* <AccordionTab disabled
           header={
            <div className="flex align-items-center line-height-2 justify-content-between">
              <div className="vertical-align-middle" style={{color:"#1D2965"}}>
                Registration related data
              </div>
            </div>
            }
        >
        </AccordionTab>
        <AccordionTab disabled
          header={
            <div className="flex align-items-center line-height-2 justify-content-between">
              <div className="vertical-align-middle" style={{color:"#1D2965"}}>
                Death related data
              </div>
            </div>
            }
        >
        </AccordionTab>
        <AccordionTab disabled
          header={
            <div className="flex align-items-center line-height-2 justify-content-between">
              <div className="vertical-align-middle" style={{color:"#1D2965"}}>
                Schemes
              </div>
            </div>
            }>

        </AccordionTab> */}
      </Accordion>
    </div>
  );
};
export default DashboardSection;
